import React, { Component } from "react";
import { RefinementList } from "react-instantsearch-dom";
import { orderBy } from "lodash";
import FilterSubSection from "~/scripts/components/products/FilterSubSection";

class ProductCategory extends Component {
    render() {
        return (
            <FilterSubSection heading="Application">
                <RefinementList
                    className="refinement-list"
                    attribute="family.applications"
                    transformItems={items =>
                        orderBy(items, ["label", "count"], ["asc", "desc"])
                    }
                    limit={100}
                />
            </FilterSubSection>
        );
    }
}

export default ProductCategory;



// WEBPACK FOOTER //
// ./public/assets/scripts/components/products/Applications.js